import { render } from "./supplier-table.vue?vue&type=template&id=ee67a000"
import script from "./supplier-table.vue?vue&type=script&lang=js"
export * from "./supplier-table.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__